import React from 'react';
import { actions } from '@ecosystem/newron-design-system';

import * as styles from './Panel.module.scss';
import classNames from 'classnames';
import { Periodicity } from '@components/time-period-selector/PeriodsTypes';

export type PanelProps = {
  applyCallback: () => void;
  closeCallback: () => void;
  periodicity: Periodicity;
};

const Panel: React.FC<PanelProps> = ({ children, applyCallback, closeCallback, periodicity }) => {
  const handleApply = () => {
    applyCallback();
    closeCallback();
  };

  const isCustomMonthOrWeek = [Periodicity.CustomMonths, Periodicity.CustomWeeks].includes(periodicity);
  const { Button } = actions;
  return (
    <div className={classNames(styles.Panel, { [styles.Panel__Custom]: isCustomMonthOrWeek })}>
      {children}
      <div className="border-t border-default px-6 py-4">
        <Button type="submit" onClick={handleApply}>
          Apply
        </Button>
        <Button mode="secondary" onClick={closeCallback}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default Panel;
